import request from '../../axios';

export interface IPostCreditStoreOrderTransactionPayload {
  store_order: string;
}

const postCreateCreditStoreOrderTransaction = async (
  payload: IPostCreditStoreOrderTransactionPayload,
) => {
  const data = await request.post(
    `/api/v2/payment/create-store-order-transaction-with-credit`,
    payload,
  );

  return data;
};

export default postCreateCreditStoreOrderTransaction;
